import React from 'react';
import './MinicartTriggerChevron.less';

import ChevronIcon from 'new-images/chevron.svg';

export const MinicartTriggerChevron = () => {
	return (
		<span
			className="minicart-trigger-chevron"
			dangerouslySetInnerHTML={{__html: ChevronIcon}}
		></span>
	);
};
